<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="tablet:flex tablet:items-center">
    <div
      class="mb-4 w-full tablet:mb-0 tablet:w-6/12 tablet:pr-2.5 desktop:pr-8"
    >
      <LightboxAlbum
        :album-name="itemData.name"
        :album-image-url="thumbnailUrl"
      />
    </div>
    <div
      class="w-full overflow-hidden tablet:w-6/12 tablet:pl-2.5 desktop:pl-8"
    >
      <h3 class="mb-4 break-words font-bold tablet:text-lg desktop:text-xl">
        {{ itemData.name }}
      </h3>
      <div
        class="markdown-content"
        v-html="provideMarkdownHtml(itemData.description, 'simple')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { IProductInfoCapabilityItem } from '@/assets/types/api/Products';

  interface IProps {
    itemData: IProductInfoCapabilityItem;
  }

  const props = withDefaults(defineProps<IProps>(), {
    itemData: () => ({
      briefTabName: '',
      name: '',
      description: '',
      webThumbnail: '',
      tabletThumbnail: '',
      mobileThumbnail: '',
    }),
  });

  const { isMobile, isTablet } = useScreen();

  const thumbnailUrl = computed((): string => {
    const { webThumbnail, tabletThumbnail, mobileThumbnail } = props.itemData;
    if (isMobile.value) return mobileThumbnail;
    if (isTablet.value) return tabletThumbnail;
    return webThumbnail;
  });
</script>
